"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
const FormDto_1 = require("../dto/FormDto");
class FormField {
    constructor() {
        this.id = 0;
        this.type = FormDto_1.FormFieldTypeDto.STRING;
        this.title = "";
        this.description = "";
        this.placeholder = "";
        this.required = false;
        this.hidden = false;
        this.options = [];
        this.order = 0;
        this.updated = 0;
    }
    static fromDto(dto) {
        const result = new FormField();
        result.id = dto.id;
        result.type = dto.type;
        result.title = dto.title;
        result.updated = dto.updated;
        if (dto.description) {
            result.description = dto.description;
        }
        if (dto.placeholder) {
            result.placeholder = dto.placeholder;
        }
        if (dto.required) {
            result.required = dto.required;
        }
        if (dto.hidden) {
            result.hidden = dto.hidden;
        }
        if (dto.options) {
            result.options = dto.options;
        }
        result.order = dto.order;
        return result;
    }
    toDto() {
        const dto = {
            id: this.id,
            type: this.type,
            title: this.title,
            order: this.order,
            updated: this.updated,
        };
        if (this.description) {
            dto.description = this.description;
        }
        if (this.placeholder) {
            dto.placeholder = this.placeholder;
        }
        if (this.required) {
            dto.required = this.required;
        }
        if (this.hidden) {
            dto.hidden = this.hidden;
        }
        if (this.hasOptions && this.options) {
            dto.options = this.options;
        }
        return dto;
    }
    valueTyped(formFieldValue) {
        switch (this.type) {
            case FormDto_1.FormFieldTypeDto.STRING:
            case FormDto_1.FormFieldTypeDto.TEXT:
            case FormDto_1.FormFieldTypeDto.EMAIL:
            case FormDto_1.FormFieldTypeDto.URL:
            case FormDto_1.FormFieldTypeDto.PHONE:
            case FormDto_1.FormFieldTypeDto.DATE:
            case FormDto_1.FormFieldTypeDto.TIME:
            case FormDto_1.FormFieldTypeDto.DROPDOWN:
            case FormDto_1.FormFieldTypeDto.CHOICE:
                return formFieldValue.value;
            case FormDto_1.FormFieldTypeDto.NUMBER:
                return Number(formFieldValue.value);
            case FormDto_1.FormFieldTypeDto.CHECKBOX:
                return formFieldValue.values.join(", ");
        }
    }
    get inputType() {
        switch (this.type) {
            case FormDto_1.FormFieldTypeDto.STRING:
            case FormDto_1.FormFieldTypeDto.TEXT:
                return "text";
            case FormDto_1.FormFieldTypeDto.EMAIL:
                return "email";
            case FormDto_1.FormFieldTypeDto.URL:
                return "url";
            case FormDto_1.FormFieldTypeDto.PHONE:
                return "tel";
            case FormDto_1.FormFieldTypeDto.DATE:
                return "date";
            case FormDto_1.FormFieldTypeDto.TIME:
                return "time";
            case FormDto_1.FormFieldTypeDto.DROPDOWN:
                return "text";
            case FormDto_1.FormFieldTypeDto.NUMBER:
                return "number";
            case FormDto_1.FormFieldTypeDto.CHOICE:
            case FormDto_1.FormFieldTypeDto.CHECKBOX:
                return "string";
        }
    }
    get hasOptions() {
        switch (this.type) {
            case FormDto_1.FormFieldTypeDto.CHOICE:
            case FormDto_1.FormFieldTypeDto.CHECKBOX:
            case FormDto_1.FormFieldTypeDto.DROPDOWN:
                return true;
            default:
                return false;
        }
    }
    get isInput() {
        switch (this.type) {
            case FormDto_1.FormFieldTypeDto.TEXT:
            case FormDto_1.FormFieldTypeDto.CHOICE:
            case FormDto_1.FormFieldTypeDto.CHECKBOX:
            case FormDto_1.FormFieldTypeDto.DROPDOWN:
                return false;
            default:
                return true;
        }
    }
    get isTextArea() {
        return this.type === FormDto_1.FormFieldTypeDto.TEXT;
    }
    get isDropdown() {
        return this.type === FormDto_1.FormFieldTypeDto.DROPDOWN;
    }
    get isCheckbox() {
        return this.type === FormDto_1.FormFieldTypeDto.CHECKBOX;
    }
    get isRadio() {
        return this.type === FormDto_1.FormFieldTypeDto.CHOICE;
    }
    get containsLongOption() {
        return this.options.filter(option => option.length > 30).length > 0;
    }
    get isMultiValue() {
        switch (this.type) {
            case FormDto_1.FormFieldTypeDto.CHECKBOX:
                return true;
            default:
                return false;
        }
    }
}
exports.FormField = FormField;
